import { BorderBottom, DisabledByDefault } from '@mui/icons-material'
import { createTheme, alpha } from '@mui/material/styles'
import ratingList from 'keys/rating'
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { position, prefixer } from 'stylis';

let paginationH = 55
let toolbarH = 70
let tabsH = 70
let titleH = 33
let fontSize = 16

const secondary = '#FB7401'
const secondary1 = '#FFB679'

const primary100 = "#E8F0F5"
const primary500 = "#325168"

const primary = '#8BBC01'
const primary2 = "#05BE24"
const thirdly = "#91BDFA"
const thirdly2 = "#CCE1FF"
const thirdly3 = "#CADDEA"
const thirdly4 = "#F5F9FF"
const thirdly5 = "#969CA5"
const thirdly6 = "#2C84FF"
const textDisabled = "#B3BDCB"
const lightPrimary = "#f6fbdb"
const lightBlue2 = "#e3f2f9"
const lightBlue3 = "#00b0f0"
const dark = '#26445A'
const done = "#3da288"
const black = "#000"
const light = "#F3F6F9"
const lightSecondary = "#FEE4D8"
const lightBlue = '#3EBCE226'
const lightOrange = '#FB5B0126'
const lightPurple = '#863EE226'
const error = '#FF0000'
const mandatory = "#E34141"
const text = "rgba(0, 0, 0, 0.50)"
const white = "#FFF"
const gray = "#B5B5B5"
const lightDark = "#416783"
const ligthGray = "rgb(221, 221, 221)"
const lightYellow = "#ffe9a5"
const yellow = "#eec808"
const success = "#188038"
const bg = "#E6F0FE"
const fieldColor = "#00000026"
const fieldTxtColor = "#B3BDCB"
const hover = "#EAF3FF"
const purple = "#9b3da2"
const rating1 = ratingList[0]
const rating2 = ratingList[1]
const rating3 = ratingList[2]
const rating4 = ratingList[3]
const rating5 = ratingList[4]

const sidebar = 200
const header = 65
const expandedHeader = 125

const gTheme = {
    thirdly: {
        main: thirdly,
        contrastText: white
    },
    thirdly1: {
        main: thirdly,
        contrastText: black
    },
    purple: {
        main: purple,
        contrastText: white
    },
    done: {
        main: done,
        contrastText: white
    },
    bg: {
        main: bg,
        contrastText: black
    },
    primary500: {
        main: primary500,
        contrastText: white
    },
    text: {
        main: text,
        contrastText: text
    },
    textDisabled: {
        main: textDisabled,
        contrastText: textDisabled
    },
    thirdly3: {
        main: thirdly3,
        contrastText: dark
    },
    thirdly4: {
        main: thirdly4,
        contrastText: dark
    },
    thirdly6: {
        main: thirdly6,
        contrastText: dark
    },
    thirdly2: {
        main: thirdly2,
        contrastText: dark
    },
    processing: {
        main: thirdly2,
        contrastText: thirdly6
    },
    gray: {
        main: gray,
        contrastText: white
    },
    primary2: {
        main: primary2,
        contrastText: white
    },
    rating1: {
        main: rating1,
        contrastText: white
    },
    lightBlue3: {
        main: lightBlue3,
        contrastText: white
    },
    lightBlue2: {
        main: lightBlue2,
        contrastText: dark
    },
    rating2: {
        main: rating2,
        contrastText: white
    },
    rating3: {
        main: rating3,
        contrastText: white
    },
    rating4: {
        main: rating4,
        contrastText: white
    },
    rating5: {
        main: rating5,
        contrastText: white
    },
    lightBlue: {
        main: lightBlue,
        contrastText: "#3EBCE2",
    },
    lightDark: {
        main: "#416783",
        contrastText: "#B6B9C7",
    },
    yellow: {
        main: yellow,
        contrastText: white
    },
    success: {
        main: success,
        contrastText: success,
    },
    lightYellow: {
        main: lightYellow,
        contrastText: dark
    },
    gray2: {
        main: ligthGray,
        contrastText: 'black'
    },
    dark: {
        main: '#26445A',
        contrastText: "white",
    },
    lightOrange: {
        main: lightOrange,
        contrastText: "#FB5B01",
    },
    ligthGray: {
        main: gray,
        contrastText: ligthGray
    },
    disabled: {
        main: "",
        contrastText: '#a0a2a3'
    },
    disabled2: {
        main: "#CAD3DF",
        contrastText: '#969CA5'
    },
    primary: {
        main: '#8BBC01',
        contrastText: "white"
    },
    lightPrimary: {
        main: lightPrimary,
        contrastText: dark
    },
    lightSecondary: {
        main: "#FEE4D8",
        contrastText: "white"
    },
    secondary: {
        main: '#FB7401',
        contrastText: "white"
    },
    primary500: {
        main: primary500,
        contrastText: "white"
    },
    secondary1: {
        main: secondary1,
        contrastText: "white"
    },
    lightPurple: {
        main: lightPurple,
        contrastText: "#863EE2",
    },
    lightGreen: {
        main: '#C1E23E59',
        contrastText: "#8BBC01",
    },
    red: {
        main: error,
        contrastText: '#FB010126',
    },
    lightRed: {
        main: '#FB010126',
        contrastText: "#FB0101",
    },
    light: {
        main: '#F3F6F9',
        contrastText: dark,
    },
    white: {
        main: white,
        contrastText: dark,
    },
    thirdly5: {
        main: thirdly5,
        contrastText: thirdly5
    }
}

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1480,
            xxl: 1780,
            xxxl: 2000,
            xxxxl: 2200 // Custom breakpoint for xxxl
        },
    },
    typography: {
        fontFamily: [
            // '-apple-system',
            // 'BlinkMacSystemFont',
            // '"Segoe UI"',
            // 'Roboto',
            // '"Helvetica Neue"',
            // 'Arial',
            // 'sans-serif',
            // '"Apple Color Emoji"',
            // '"Segoe UI Emoji"',
            // '"Segoe UI Symbol"',

            "Calibri", "sans-serif"

        ].join(',')
    },

    // direction: 'rtl',
    palette: gTheme,
    components: {
        MuiSwitch: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    '.MuiSwitch-root': {
                        width: 35
                    },
                    '.MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
                        backgroundColor: thirdly
                    },
                    '.MuiSwitch-track': {
                        height: 6,
                        position: "relative",
                        top: 4,
                        background: "#c8c6c6"
                    },
                    '.MuiSwitch-thumb': {
                        width: 18,
                        height: 18,
                        backgroundColor: '#9E9E9E',
                        boxShadow: "none"
                    },
                    '.Mui-checked': {
                        transform: 'translateX(16px)',
                        color: '#fff',
                        '.MuiSwitch-thumb': {
                            backgroundColor: thirdly,
                            opacity: 1,
                            border: 0,
                        },
                    }
                })
            }
        },
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.variant === 'outlined' &&
                    // ownerState.color === 'primary' && 
                    {
                        color: dark,
                    }),
                    fontWeight: "400",
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                }),
            },
        },
        MuiLoadingButton: {
            styleOverrides: {
                root: () => ({
                    boxShadow: 'none'
                }),
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: () => ({
                    color: '#fff',
                    zIndex: theme.zIndex.drawer + 1
                }),
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: ({ }) => ({
                    fontFamily: [
                        "Calibri", "sans-serif"
                    ].join(','),
                    '.MuiButtonBase-root.MuiIconButton-root.Mui-disabled': {
                        opacity: 0.7,
                    }
                })
            }
        },
        MuiButtonGroup: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    direction: "ltr"
                }),
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: 16,
                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                root: () => ({
                    '.MuiPaper-root.MuiPopover-paper.MuiMenu-paper': {
                        borderRadius: 15,
                        boxShadow: "0px 0px 18.2px 0px #0000000D",
                        border: "1px solid #CBE1FF"
                    },
                })
            },
        },
        MuiTab: {
            styleOverrides: {
                root: () => ({
                    fontSize: '16px'
                }),
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: () => ({
                    width: "auto !important"
                }),
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    alignItems: "center",
                    borderRadius: 12,
                    borderWidth: 1,
                    borderStyle: "solid",
                    ...(ownerState.color === 'error' && {
                        backgroundColor: '#fde8e8', // צבע רקע לדוגמה (אדום בהיר)
                        borderColor: '#f5c6cb',     // צבע מסגרת
                        color: '#721c24',           // צבע הטקסט
                    }),

                    // הגדרת עיצוב כאשר נשלח color="thirdly"
                    ...(ownerState.color === 'thirdly' && {
                        backgroundColor: "#dae7f8", // צבע רקע לדוגמה (ירוק בהיר/אחר לבחירתך)
                        borderColor: thirdly2,     // צבע מסגרת
                    }),
                }),
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: () => ({
                    margin: "5px 5px 5px 5px",
                    width: "50px",
                    display: "flex",
                    alignItems: "center",
                }),
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: () => ({
                }),
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: () => ({
                    background: bg
                }),
            }
        },
        MuiFab: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    "&:hover": {
                        backgroundColor: 'primary.main',
                        // opacity: 0.9
                    }
                }),
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    // "&:hover .MuiOutlinedInput-notchedOutline": {
                    //     cursor: "pointer",
                    //     boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
                    //     borderColor: theme.palette.primary.main,
                    // },
                    "& .MuiOutlinedInput-notchedOutline": {
                        // borderRadius: 35,
                        // border: `1px solid ${thirdly3}`,
                    }
                })
            }
        },
        MuiInput: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    // "&:hover .MuiOutlinedInput-notchedOutline": {
                    //     background: "white"
                    // },
                    // "&:focused .MuiOutlinedInput-notchedOutline": {
                    //     background: "white"
                    // }
                    // "&:hover .MuiOutlinedInput-notchedOutline": {
                    //     cursor: "pointer",
                    //     boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
                    //     borderColor: theme.palette.primary.main,
                    // }
                })
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    // border: `1px solid ${thirdly3}`,
                    // transition: theme.transitions.create([
                    //     'border-color',
                    //     'background-color',
                    //     'box-shadow',
                    // ]),
                    '&:focus': {
                        background: white
                    },
                }),
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    borderBottom: '1px solid #EFF2F5',
                    marginBottom: '10px',
                    fontSize: '17px'
                }),
            },
        },
        MuiLinearProgress: {
            styleOverrides: {

            }
        }
    }
},

)

const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

const cacheLtr = createCache({
    key: 'muiltr',
    stylisPlugins: [prefixer],
});

export {
    expandedHeader, hover, primary500, primary100, fontSize, paginationH, toolbarH, secondary1, tabsH, cacheLtr, fieldColor, fieldTxtColor, cacheRtl, thirdly4, thirdly5, thirdly, bg, lightDark, done, yellow, rating1, lightSecondary, rating2, rating3, rating4, rating5,
    textDisabled, thirdly6, lightBlue2, lightPrimary, text, thirdly2, thirdly3, titleH, ligthGray, gTheme, gray, header, sidebar, white, mandatory, error, primary, secondary, dark, black, light, lightBlue, lightPurple, lightOrange
}
export default theme